import {ChangeEvent, useContext, useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {AppContext} from "../../../../../appContext/AppContext";
import InputSearch from "../../../../../component/InputSearch";
import {TableCustom} from "../../../../../component/table/table-custom/TableCustom";
import TextField from "../../../../../component/TextField";
import {
    CODE,
    DEFAULT_PAGE_INDEX,
    KEY,
    SELECTION_MODE,
    TYPE_WH,
} from "../../../../../utils/Constant";
import {DanhSachThongTinYLenh} from "../../../../../phan-he-nhap-kho/constants/ColumnsNhapKho";
import {getDsThongTinYLenh} from "../../../../services/servicesXuatKho";
import ModelHeader from "../../../../../component/ModelHeader";

interface Props {
    LST_WAREHOUSE: any
    warehouseId: any,
    show: boolean,
    initialValues: any;
    onHide: () => void;
}

export const DialogThongTinYLenh = (props: Props) => {
    const {warehouseId, LST_WAREHOUSE, show, initialValues, onHide} = props;
    const [dsPhieuNhapKho, setDsPhieuNhapKho] = useState<any[]>([]);
    const {setIsLoading} = useContext(AppContext);
    const [searchData, setSearchData] = useState<any>();
    const [rowsPerPage, setRowsPerPage] = useState<number>(20);
    const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
    const currentWh = LST_WAREHOUSE[warehouseId as keyof typeof LST_WAREHOUSE];

    const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchData({
            ...searchData,
            [e.target.name]: e.target.value,
        });
    };

    const updatePageData = async () => {
        try {
            setIsLoading(true);
            const {data} = await getDsThongTinYLenh({
                // ...searchData,
                keyword: searchData?.keyword?.trim() || null,
                type: TYPE_WH.EXPORT,
                // pageSize: rowsPerPage,
                // pageIndex: page,
                // warehouseId: warehouseId,
                slipId: initialValues.xuatKho?.id
            });
            if (CODE.SUCCESS === data.code) {
                setDsPhieuNhapKho(data?.data?.content || []);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        updatePageData();
    }, [rowsPerPage, page]);

    const handlerSearchKeyWorld = () => {
        setPage(DEFAULT_PAGE_INDEX);
        setRowsPerPage(20);
        updatePageData()
    }

    return (
        <Modal
            centered
            show={show}
            // onHide={onHide}
            size="xl"
            fullscreen
            className="page-full spaces h-calc-vh-50"
        >
            <ModelHeader onHide={onHide} title={`Thông tin y lệnh`} />
            <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10 pt-10 row mb-10">
                    <div className="col-lg-3">
                        <TextField
                            label="Khoa"
                            name="departmentName"
                            type="text"
                            // disabled
                            className="d-flex spaces width-100"
                            value={initialValues?.xuatKho?.departmentName || ''}
                            labelClassName="spaces mt-4 mr-5"
                        />
                    </div>
                    <div className="col-lg-3">
                        <TextField
                            label="Kho nhận"
                            name="mateWhName"
                            type="text"
                            // disabled
                            className="d-flex spaces width-100"
                            value={currentWh?.mateWhName || ''}
                            labelClassName="spaces  mt-4 mr-5"
                        />
                    </div>
                    <div className="col-lg-6 bg-white ">
                        <InputSearch
                            name="keyword"
                            value={searchData?.keyword || ''}
                            placeholder="Tìm kiếm"
                            handleChange={handleChangeSearchData}
                            handleSearch={() => handlerSearchKeyWorld()}
                            handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                            className="spaces h-31 pr-4 radius-3"
                        />
                    </div>
                </div>
                <div className="spaces bg-white mb-0">
                    <TableCustom<any>
                        className="spaces h-bang-ds-phieu"
                        data={dsPhieuNhapKho}
                        columns={DanhSachThongTinYLenh}
                        verticalScroll={true}
                        selectionMode={SELECTION_MODE.MULTI}
                    />
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default DialogThongTinYLenh;
